import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';

import { UserProvider } from '../../providers/user/user';

@IonicPage()
@Component({
  selector: 'page-coming-soon',
  templateUrl: 'coming-soon.html',
})
export class ComingSoonPage {

  constructor(public navCtrl: NavController,
    public user: UserProvider,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public translateService: TranslateService,
    private iab: InAppBrowser,
    public storage: Storage) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ComingSoonPage');
  }

  loginFacebook(){
    console.log('login Facebook()');
    let loader = this.loadingCtrl.create({
      content: "logging you in..."
    });
    loader.present();
    this.user.loginFacebook().then((profile)=>{
      // once they have logged in with FB then we log them in locally
      loader.dismiss();
      loader = this.loadingCtrl.create({
        content: "syncing..."
      });
      loader.present();
      /*
      this.user.login().subscribe((res) => {
        loader.dismiss();
        if(res.success == '1'){
          // logged in, launch the main app
          //this.gotoHomepage();
        } else {
          // failed to login our end, promt to try again
          let alert = this.alertCtrl.create({
            title: 'Login Error',
            message: 'Login failed - please check your connection and try again'
          });
          alert.present();
        }
      });
      */
    }).catch((e)=>{
      loader.dismiss();
      let alert = this.alertCtrl.create({
        title: 'FB Login Error',
        message: e + " You must log in with Facebook to use Finstr",
      });
      alert.present();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/coming-soon/coming-soon.ts